import { render, staticRenderFns } from "./EditPatientInfoTab.vue?vue&type=template&id=20d1b86e&"
import script from "./EditPatientInfoTab.vue?vue&type=script&lang=js&"
export * from "./EditPatientInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./EditPatientInfoTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports